
define(
	'Code25.CaterpartsGlobal.AccountHold'
	, [
		"Utils", "Profile.Model", 'Backbone.View'
	]
	, function (
		Utils, ProfileModel, BackboneView
	) {
		'use strict';
		return {
			mount: function mount(container) {


				var OrderWizardModuleSubmitButton = require('OrderWizard.Module.SubmitButton');
				if (OrderWizardModuleSubmitButton.OrderWizardModuleSubmitButton) {
					OrderWizardModuleSubmitButton = OrderWizardModuleSubmitButton.OrderWizardModuleSubmitButton;
				}

				function parseNumber(value){
					value=parseFloat(value);
					if(isNaN(value)){
						value=0;
					}
					if(value<0){
						value=0;
					}
					return value;
				}

				_.extend(OrderWizardModuleSubmitButton.prototype, {



					isValid: function () {
						var self = this;

						var current_step = this.options.wizard.getCurrentStep();
						var step = current_step.options.step_url;
						var state = current_step.state;
						var profile = ProfileModel.getInstance();
						var test=false;

self.isReady=true; //half test on review page

						if (test||(step == "review" && state != "future" && profile.get('isGuest') == 'F' && self.isReady == true)) {
												
							if (profile) {

								var paymentmethods=this.model.get("paymentmethods");
									
									if(paymentmethods.length>0){
										var type=paymentmethods.models[0].get("type");
										if(type!="invoice"){
											return jQuery.Deferred().resolve();
										}
									}

								var percentage = 0, unbilledpercentage = 0, totalpercentage=0,creditlimit = profile.get('creditlimit');
								if (creditlimit > 0) {
									var balance=parseNumber(profile.get('balance'));
									percentage = Math.min(
										(balance * 100) / creditlimit,
										100
									);
									
									var unbilledorders=parseNumber(profile.get('unbilledorders'));
									unbilledpercentage = Math.min(
										(unbilledorders * 100) / creditlimit,
										100
									);
									
									var total = parseNumber(self.model.get('summary').total);
									totalpercentage = Math.min(
										(total * 100) / creditlimit,
										100
									);
									var view = new BackboneView({
										application: self.options.wizard.application
									});
									
									
									view.setTitle(Utils.translate('Your Account is on Hold'));
									if (percentage + unbilledpercentage + totalpercentage>100||test) {
										var message = Utils.translate('Your account balance is '+Utils.formatCurrency(balance)+' and your have '+Utils.formatCurrency(unbilledorders)+' of unbilled orders.<br /><br />This order of '+Utils.formatCurrency(total)+' will exceed your current credit limit of '+Utils.formatCurrency(creditlimit)+'.<br /><br />Please <a href="#/invoices" data-touchpoint="customercenter" data-hashtag="#/invoices" name="Invoices"" data-touchpoint="invoices">review and pay open invoices</a> or <a href="#/newcase" data-touchpoint="customercenter" data-hashtag="#/newcase" data-touchpoint="newcase">contact us</a> about potentially increasing your credit limit.')
										view.render = function () {
											this.$el.append('<p class="success success-message" data-confirm-message>'+message+'</p>');
										};
										view.showInModal();

										return jQuery.Deferred().reject();
									}
								}
							}
						}

						return jQuery.Deferred().resolve();
					},
				});

			}

		}

	});
